module.exports = __webpack_public_path__ + "media/src/images/apple-icon-180x180-59d4fd0c034f4b3dc06dc02610db8656.png";